import { appHref } from '../routing/browser';

export function BrandMark() {
  return <img className="brand-mark" src={appHref('assets/designforge-logo.svg')} width="148" height="148" alt="" aria-hidden="true" />;
}
